export const ALERT_TYPE_ERROR = 'error'
export const ALERT_TYPE_SUCCESS = 'success'
export const ALERT_TYPE_INFO = 'info'
